module.exports = __webpack_public_path__ + "img/law2-m@1.f053c425.webp";